<template>
    <div id="app">
        <router-view/>
        <div class="shadedianshow">
            <div class="dianshowrelacon">
                <div class="relatitle clearfix">
                    店铺到期
                </div>
                <div class="reladetail">
                    <p class="reladtext">店铺已到期，请订购续费后再进行操作</p>
                    <div class="relabut clearfix">
                        <div class="relaleft fl" @click="showcloserela">取消</div>
                        <div class="relaright fl" @click="showgopri">去续费</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {}
    },
    methods: {
        showcloserela() {
            $('.shadedianshow').fadeOut();
        },
        showgopri() {
            $('.shadedianshow').fadeOut();
            var that = this;
            that.$router.push({
                path: '/flowBook',
            })
        },
    },
    watch: {
        '$route'(to, from) {
            $('.shadedianshow').fadeOut();
        }
    },
    mounted() {
        // var top = document.getElementById('DataDiv').scrollTop;
        // document.body.scrollTop = document.documentElement.scrollTop = 0;
        // console.log(top);
    }
}
</script>

<style scoped="scoped">
.dianshowrelacon {
    width: 400px;
    padding: 0 30px 0px;
    position: relative;
    left: 50%;
    margin-left: -200px;
    background: #fff;
    border-radius: 4px;
    top: 20%;
    z-index: 99;
}

.dianshowrelacon .relatitle {
    height: 50px;
    line-height: 50px;
    border-bottom: 1px solid #EBEEF5;
    color: #303133;
    font-weight: bold;
    font-size: 18px;
    text-align: center;
}

.dianshowrelacon .reladetail {
    min-height: 50px;
    padding-top: 30px;
}

.dianshowrelacon .reladtext {
    color: #333;
    font-size: 16px;
    text-align: center;
}

.dianshowrelacon .reladtext span {
    color: #409EFF !important;
    cursor: pointer;
}

.dianshowrelacon .relabut {
    height: 50px;
    width: 340px;
    border-top: 1px solid #EBEEF5;
    font-size: 16px;
    line-height: 50px;
    margin-top: 34px;
    cursor: pointer;
}

.dianshowrelacon .relabut div {
    width: 170px;
    text-align: center;
}

.dianshowrelacon .relabut .relaleft {
    border-right: 1px solid #EBEEF5;
    color: #333;
}

.dianshowrelacon .relabut .relaright {
    color: #409EFF;
}


</style>



// WEBPACK FOOTER //
// src/App.vue